module.exports = __webpack_public_path__ + "img/down_arrow_pink_icon.678d3e7a.svg";